<template>
  <div class="app-container">
    <div class="anjian-wrap">
      <div class="common-section-bg anjian-shaixuan">
        <div class="shaixuan-item">
          <el-button @click="handleCreate(null)"
                     type="primary"
                     style="background: #1067E0;border: #1067E0;"
                     icon="el-icon-plus">
            {{ $t("table.add") }}
          </el-button>
        </div>
      </div>
      <div class="common-section-bg common-section-top biaoge-data">
        <el-table :key="tableKey"
                  :data="list"
                  v-loading="listLoading"
                  style="width: 100%"
                  row-key="id"
                  default-expand-all
                  :tree-props="{
                        children: 'children',
                        hasChildren: 'hasChildren',
                    }">
          <el-table-column :label="$t('user.permissionName')"
                           prop="name"
                           min-width="180">
          </el-table-column>
          <el-table-column :label="$t('user.permissionType')"
                           prop="type"
                           width="180">
            <template slot-scope="scope">{{
                            scope.row.type == "1" ? "页面" : "接口"
                        }}</template>
          </el-table-column>
          <el-table-column :label="$t('user.permissionPath')"
                           prop="path"
                           min-width="180">
          </el-table-column>
          <el-table-column :label="$t('user.permissionIsShow')"
                           prop="is_show"
                           align="center"
                           width="150">
            <template slot-scope="scope">
              <el-button type="success"
                         size="mini"
                         plain
                         v-if="scope.row.is_show === 1">显示</el-button>
              <el-button type="danger"
                         size="mini"
                         plain
                         v-else>隐藏</el-button>
            </template>
          </el-table-column>
          <el-table-column width="150"
                           :label="$t('table.sort')">
            <template slot-scope="scope">
              <el-input-number size="mini"
                               style="width: 100px"
                               v-model="scope.row.sort"
                               controls-position="right"
                               @change="handleChange(scope.row)"
                               :min="0"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.createdAt')"
                           prop="created_at"
                           width="170">
          </el-table-column>
          <el-table-column :label="$t('table.updatedAt')"
                           prop="updated_at"
                           width="170">
          </el-table-column>
          <el-table-column :label="$t('table.actions')"
                           fixed="right"
                           align="center"
                           width="250"
                           class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button @click="handleCreate(scope.row)"
                         style="background: #1067E0;border: #1067E0;"
                         type="primary">
                {{ $t("table.add") }}
              </el-button>
              <el-button @click="handleUpdate(scope.row)"
                         style="background: #1067E0;border: #1067E0;"
                         type="primary">
                {{ $t("table.edit") }}
              </el-button>
              <el-button @click="handleDelete(scope.row)"
                         style="background: #FF4040;border: #FF4040;"
                         type="primary">
                {{ $t("table.delete") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-drawer custom-class="custom-drawer"
               :visible.sync="dialogFormVisible"
               :close-on-press-escape="false"
               :wrapper-closable="false"
               :show-close="false"
               size="532px">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ textMap }}</div>
          <i class="el-icon-circle-close close-btn pointer"
             @click="dialogFormVisible = false" />
        </div>
      </template>
      <div class="custom-content">
        <el-form ref="dataForm"
                 :rules="rules"
                 :model="temp"
                 label-position="right"
                 :label-width="formLabelWidth"
                 v-loading="dialogFormLoading">
          <el-form-item :label="$t('user.parentPermission')">
            <el-cascader :value="temp.parentid"
                         :options="list"
                         :props="{
                                checkStrictly: true,
                                label: 'name',
                                value: 'id',
                            }"
                         clearable
                         @change="handleParentPermissionChange"></el-cascader>
          </el-form-item>
          <el-form-item :label="$t('user.permissionName')"
                        prop="name">
            <el-input v-model="temp.name" />
          </el-form-item>
          <el-form-item :label="$t('user.permissionType')"
                        prop="type">
            <el-radio v-model="temp.type"
                      label="1">{{
                            $t("user.page")
                        }}</el-radio>
            <el-radio v-model="temp.type"
                      label="2">{{
                            $t("user.api")
                        }}</el-radio>
          </el-form-item>
          <el-form-item :label="$t('route.components')"
                        prop="component"
                        v-if="temp.type === '1'">
            <el-input v-model="temp.component" />
          </el-form-item>
          <el-form-item :label="$t('user.permissionPath')"
                        prop="path">
            <el-input v-model="temp.path" />
          </el-form-item>
          <el-form-item :label="$t('user.routeName')"
                        prop="route_name"
                        v-if="temp.type === '1'">
            <el-input v-model="temp.route_name" />
          </el-form-item>
          <el-form-item :label="$t('user.routeRedirect')"
                        v-if="temp.type === '1'">
            <el-input v-model="temp.redirect" />
          </el-form-item>
          <el-form-item :label="$t('user.icon')"
                        v-if="temp.type === '1'">
            <el-input v-model="temp.icon" />
          </el-form-item>
          <el-form-item :label="$t('user.cache')"
                        v-if="temp.type === '1'">
            <el-switch v-model="temp.is_cache"
                       active-color="#13ce66"
                       inactive-color="#ff4949"
                       :active-value="1"
                       :inactive-value="2">
            </el-switch>
          </el-form-item>
          <el-form-item :label="$t('user.permissionIsShow')"
                        v-if="temp.type === '1'">
            <el-switch v-model="temp.is_show"
                       active-color="#13ce66"
                       inactive-color="#ff4949"
                       :active-value="1"
                       :inactive-value="2">
            </el-switch>
          </el-form-item>
        </el-form>
        <div class="fix-fotter">
          <div class="default-btn pointer"
               @click="
                            dialogStatus === 'create'
                                ? createData()
                                : updateData()
                        ">
            {{ $t("table.confirm") }}
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  fetchList,
  fetchPermission,
  createPermission,
  updatePermission,
  delPermission,
  sort,
} from "@/api/permission";
import waves from "@/directive/waves"; // Waves directive

export default {
  name: "UserPermission",
  components: {},
  directives: {
    waves,
  },
  data () {
    var validateName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("user.permissionNameRequired")));
      } else {
        callback();
      }
    };
    var validatePath = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("user.permissionPathRequired")));
      } else {
        callback();
      }
    };
    var validateComponent = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("user.routeComponentRequired")));
      } else {
        callback();
      }
    };
    var validateRouteName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("user.routeNameRequired")));
      } else {
        callback();
      }
    };
    return {
      tableKey: 0,
      list: [],
      listLoading: true,
      listQuery: {},
      temp: {
        id: undefined,
        name: "",
        type: "1",
        path: "",
        parentid: 0,
        is_show: 1,
        component: "",
        route_name: "",
        redirect: "",
        is_cache: 1,
        icon: "",
      },
      dialogFormVisible: false,
      dialogStatus: "",
      rules: {
        name: [
          {
            required: true,
            validator: validateName,
            trigger: "blur",
          },
        ],
        path: [
          {
            required: true,
            validator: validatePath,
            trigger: "blur",
          },
        ],
        component: [
          {
            required: true,
            validator: validateComponent,
            trigger: "blur",
          },
        ],
        route_name: [
          {
            required: true,
            validator: validateRouteName,
            trigger: "blur",
          },
        ],
      },
      dialogFormLoading: false,
    };
  },
  computed: {
    formLabelWidth: function () {
      return this.$store.getters.language === "zh" ? "100px" : "200px";
    },
    textMap: function () {
      return this.dialogStatus === "update"
        ? this.$t("form.edit")
        : this.$t("form.create");
    },
  },
  created () {
    this.getList();
  },
  watch: {
    "temp.type": function () {
      this.$refs["dataForm"].clearValidate();
    },
  },
  methods: {
    handleParentPermissionChange (value) {
      if (value.length === 0) {
        this.temp.parentid = 0;
      } else {
        this.temp.parentid = value[value.length - 1];
      }
    },
    getList () {
      this.listLoading = true;
      fetchList(this.listQuery).then((response) => {
        this.list = this.localPermissionTree(response.result.tree);
        this.listLoading = false;
      });
    },
    localPermissionTree (tree) {
      tree.forEach((permissionItem) => {
        permissionItem.name = this.$te("route." + permissionItem.name)
          ? this.$t("route." + permissionItem.name, "zh")
          : permissionItem.name;
        if (
          permissionItem.children &&
          permissionItem.children.length > 0
        ) {
          this.localPermissionTree(permissionItem.children);
        }
      });
      return tree;
    },
    handleFilter () {
      this.listQuery.page = 1;
      this.getList();
    },
    resetTemp () {
      this.temp = {
        id: undefined,
        name: "",
        type: "1",
        path: "",
        parentid: 0,
        is_show: 1,
        component: "",
        route_name: "",
        redirect: "",
        is_cache: 1,
        icon: "",
      };
    },
    handleCreate (row) {
      this.resetTemp()
      if (row !== null) {
        this.temp.parentid = row.id
      }

      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    createData () {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          createPermission(this.temp).then((res) => {
            if (res.code === 200) {
              this.dialogFormVisible = false;
              this.$message.success(
                this.$t("form.createSuccess")
              );
              this.handleFilter();
            }
          });
        }
      });
    },
    handleUpdate (row) {
      let that = this;
      this.dialogFormLoading = true;
      this.resetTemp();
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
      fetchPermission(row.id).then((res) => {
        console.log("查详情====", res);
        that.temp = {
          id: res.result.id,
          name: res.result.name,
          type: res.result.type + "",
          path: res.result.path,
          parentid: res.result.parentid ? res.result.parentid : 0,
          is_show: res.result.is_show,
          component: res.result.component,
          route_name: res.result.route_name,
          redirect: res.result.redirect,
          is_cache: res.result.is_cache,
          icon: res.result.icon,
        };
        that.dialogFormLoading = false;
      });
    },
    updateData () {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          updatePermission(this.temp).then(() => {
            this.dialogFormVisible = false;
            this.$message.success(this.$t("form.updateSuccess"));
            this.handleFilter();
          });
        }
      });
    },
    handleDelete (row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delPermission({
            id: row.id,
          }).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t("form.delSuccess"));
              this.handleFilter();
            }
          });
        })
        .catch(() => { });
    },
    // 排序变更
    handleChange (row) {
      let params = {
        id: row.id,
        sort: row.sort
      };
      sort(params).then(res => {
        if (res.code == 200) {
          this.handleFilter();
        } else {
          this.handleFilter();
          this.$message.error(res.message);
        }
      })
    },
  },
};
</script>